<template>
  <div class="right-drawer" @mousedown="mousedown" :class="isShowRight?'':'active'" @mouseenter="isShowIcon=true" @mouseleave="isShowIcon=false" v-show="isShow">
<!--    <Icon v-show="isShowIcon || !isShowRight" type="big" name="el-icon-d-arrow-right" @click.native="showPanel"></Icon>-->
    <div v-show="(isShowIcon || !isShowRight) && !isDrawState" class="arrow" @click="showPanel" :class="!isShowRight?'active':''"><i class="el-icon-arrow-right"></i></div>
    <div class="content">
      <slot>
        <div class="header">
          <slot name="header"></slot>
        </div>
        <div class="body">
          <slot name="body"></slot>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { PermissionLevel } from '@/configs/constants'
export default {
  name: 'RightDrawer',
  props: {
    stopPropagation: {
      type: Boolean,
      default: true
    },
    hiddenDrawer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isShowRight', 'isDrawState', 'permissionLevel']),
    isShow () {
      return !this.shared && !this.hiddenDrawer
    }
  },
  inject: ['shared'],
  data () {
    return {
      isShowIcon: false
    }
  },
  watch: {
    isShowRight (val) {
      this.$store.dispatch('setRightDrawVisible', val && this.isShow)
    }
  },
  mounted () {
    this.$store.dispatch('setRightDrawVisible', this.isShowRight && this.isShow)
  },
  destroyed () {
    this.$store.dispatch('setRightDrawVisible', false)
  },
  methods: {
    showPanel () {
      this.$store.dispatch('showRight', !this.isShowRight)
    },
    mousedown (event) {
      this.stopPropagation && event.stopPropagation()
    }
  }
}
</script>

<style lang="scss" scoped>
.right-drawer{
  box-sizing: border-box;
  transition: all 0.3s;
  display: inline-block;
  position: absolute;
  top: 0px;
  // top: 48px;
  right: 0px;
  width: 260px;
  height: 100%;
  background: #2C2D2E;
  box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-left: 1px solid #000000;
  z-index: 1;
  .content{
    height: 100%;
    .header{
      height: 40px;
      border-bottom: 1px solid #000000;
    }
  }
  .body{
    height: 860px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  >.custom-icon{
    position: absolute;
    left: -32px;
    top: 400px;
    z-index: 1000;
  }
  .arrow{
    position: absolute;
    left: -16px;
    top: 400px;
    z-index: 1000;
    width: 32px;
    height: 32px;
    background: #0098F0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
    &.active{
      transform: rotate(180deg);
      left: -20px;
    }
  }
  &.active{
    // width: 0;
    // .content{
    //   display: none;
    // }
    right: -260px;
  }
}
</style>
